"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_OPTION_KEYWORDS = void 0;
exports.COLOR_OPTION_KEYWORDS = ['color', 'colour'];
